import {inject, Injectable} from '@angular/core';
import {getAssetIcon} from '../../../components/asset/asset-icons';
import {
    DexSecuritiesSubjectService
} from '../../../components/dex/dex-streaming/subjects/dex-securities-subject-service';
import {DelClassificationReferentialAsset} from '../../../components/dex/dex-streaming/types/del-classifcation';
import {DisplayDecimal} from '../../../components/symbol-decimals';
import {createDisplayDecimalFromBigint} from '../../../components/symbol-decimals/display-decimal-bigint';
import {DynAsset, DynDisplayAsset} from './dyn-wallet-row';

type DisplayDecimalFormatter = (value: bigint) => DisplayDecimal<string>;

@Injectable()
export class DynDisplayAssetFactory {

    private readonly assetFormatByKeyCache = new Map<string, DisplayDecimalFormatter>();

    private readonly dexSecuritiesSubjectService = inject(DexSecuritiesSubjectService);

    public createDisplayAsset(asset: DynAsset): DynDisplayAsset {
        const {name, symbol, deliverable} = asset;
        const formatQty = this.getAssetQuantityFormatter(asset);
        let iconSymbol = symbol;

        const refDelInfo = (deliverable.classification as DelClassificationReferentialAsset)
            .referencing_asset;

        if (refDelInfo) {
            const refDelId = Number(refDelInfo.referenced_deliverable_id);
            const refDel = this.dexSecuritiesSubjectService.getDeliverableById(refDelId);

            if (refDel) {
                iconSymbol = refDel.symbol;
            }
        }

        const assetIcon = getAssetIcon(iconSymbol);

        return {
            asset,
            name,
            symbol,
            assetIcon,
            formatQty,
            deliverable
        };
    }

    public getAssetQuantityFormatter(asset: DynAsset): DisplayDecimalFormatter {
        const assetCacheKey = this.getAssetCacheKey(asset);
        let formatter = this.assetFormatByKeyCache.get(assetCacheKey);

        if (!formatter) {
            formatter = value => createDisplayDecimalFromBigint(value || 0n, asset.decimals);

            this.assetFormatByKeyCache.set(assetCacheKey, formatter);
        }

        return formatter;
    }

    public getAssetCacheKey(asset: DynAsset): string {
        return [
            asset.networkId || '*',
            asset.address || '*',
            asset.symbol || '*'
        ].join('_');
    }

}
